<template>
  <van-popup v-model="show" :close-on-click-overlay="false">
    <div class="activity-wrap">
      <h3>送福利啦！</h3>
      <i>- 充值即可参与 100%中奖 -</i>
      <span>1-188元</span>
      <img src="@/assets/images/activity/button.png" @click="take">
    </div>
    <img src="@/assets/images/activity/close.png" @click="close">
  </van-popup>
</template>

<script>
export default{
  name:'activity',
  data(){
    return{
      show:false,
    }
  },
  methods:{
    take(){
      location.href=location.protocol+'//'+location.host+'/pay-technician'
    },
    open(){
      this.show=true
    },
    close(){
      this.show=false
    }
  }
}
</script>

<style lang="scss" scoped>
.van-popup{
  font-family: Source Han Sans CN;
  background: transparent;
  display: flex;
  align-items: center;
  flex-direction: column;

  .activity-wrap{
    text-align: center;
    width: 749px;
    height: 930px;
    background: url("~@/assets/images/activity/activity-bg.png") no-repeat center/100% 100%;
    padding-top: 430px;
    display: flex;
    flex-direction: column;
    align-items: center;
    h3{
      padding-left: 70px;
      margin-bottom: 32px;
      font-size: 80px;
      font-weight: 600;
      color: #FFFFFF;
      background: linear-gradient(0deg, #F5CC7C 0%, #F9EAB1 48.2421875%, #F5CC7C 100%);
      -webkit-background-clip: text;
      -webkit-text-fill-color: transparent;
    }
    i{
      margin-bottom: 10px;
      font-size: 36px;
      font-weight: 400;
      font-style: italic;
      color: #FEFFB3;
    }
    span{
      font-size: 100px;
      font-weight: bold;
      color: #FEFFB3;
      text-shadow: 0px 3px 7px rgba(183, 0, 23, 0.65);
    }
    img{
      margin-top: 10px;
      width: 450px;
      height: 93px;
    }
  }
  >img{
    margin-top: 60px;
    width: 82px;
    height: 82px;
  }
}

</style>
